import { render, staticRenderFns } from "./tagihan-agen.vue?vue&type=template&id=2cb3c4e9&scoped=true&"
import script from "./tagihan-agen.vue?vue&type=script&lang=js&"
export * from "./tagihan-agen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3c4e9",
  null
  
)

export default component.exports